import { useState, useEffect } from 'react';
import { apiService, PortfolioItem } from '../services/api';

export const usePortfolioDetail = (slug: string) => {
  const [portfolio, setPortfolio] = useState<PortfolioItem | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPortfolioDetail = async () => {
      if (!slug) {
        setError('Portfolio slug cannot be empty');
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);

        const portfolioData = await apiService.getPortfolioBySlug(slug);
        setPortfolio(portfolioData);
      } catch (err) {
        console.error('Failed to fetch portfolio detail:', err);
        setPortfolio(null);
        setError(err instanceof Error ? err.message : 'Failed to load portfolio details. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchPortfolioDetail();
  }, [slug]);

  return { portfolio, loading, error, refetch: () => window.location.reload() };
};
